import {useApi} from 'src/PWM/hooks/use-api';
import {useAnalytics} from 'src/PWM/hooks/use-analytics';
import {IVendorEntity, IVendorListEntity, IVendorListItemClassificationAssignmentEntity, Vendor} from 'pwm-shared/dist/types';
import {API} from 'pwm-shared/src/types';

const ProjectVendorsRoute: Vendor.Endpoint = 'vendors';
const VendorAction: Vendor.EndpointActionParam = 'vendor';
const RefreshCslbAction: Vendor.EndpointActionParam = 'validateCslb';
const RefreshDirAction: Vendor.EndpointActionParam = 'validateDir';
const InactivateAssignmentAction: Vendor.EndpointActionParam = 'inactivateAssignment';

export const useVendorApi = () => {
  const authenticatedApiClient = useApi();
  const {log} = useAnalytics();
  if (!authenticatedApiClient) return log.error('Authenticated API unavailable');
  const client = authenticatedApiClient.getClient();
  if (!client) return log.error('Authenticated API Client unavailable');
  return {
    vendorAssignmentInactive(params: Vendor.VendorAssignmentInactiveData) {
      return client.put<API.Response<any>>(`${ProjectVendorsRoute}/${InactivateAssignmentAction}`, params);

    },
    getVendorDetail(vendorId: string | number) {
      const params: Vendor.GetVendorInfoParams = {vendorId};
      return client.get<API.Response<Vendor.GetVendorInfoResponse>>(`${ProjectVendorsRoute}/detail`, {params});
    },
    async getVendorAssignments(vendorId: number) {
      const params = {vendorId};
      return client.get<API.Response<GetVendorProjectsResponse[]>>(`${ProjectVendorsRoute}/projects`, {params});
    },
    async getVendorAssignment(vendorAssignmentId: number | string): Promise<API.Response<Vendor.GetProjectVendorInfoResponse>> {
      const params: Vendor.GetProjectVendorInfoParams = {vendorAssignmentId};
      const {data} = await client.get<API.Response<Vendor.GetProjectVendorInfoResponse>>(ProjectVendorsRoute, {params});
      return data;
    },
    async getVendorValidationPDF(validationId: number): Promise<Vendor.GetVendorValidations> {
      const params: Vendor.GetVendorValidationParam = {validationId};
      const {data} = await client.get<API.Response<Vendor.GetVendorValidations>>(ProjectVendorsRoute, {params});
      return data.data;
    },
    refreshDirInfo(params: Vendor.RevalidateDIRParams) {
      return client.put<API.Response<any>>(`${ProjectVendorsRoute}/${RefreshDirAction}`, params);
    },
    refreshCslbInfo(params: Vendor.RevalidateCSLBParams) {
      return client.put<API.Response<any>>(`${ProjectVendorsRoute}/${RefreshCslbAction}`, params);
    },
    updateVendor(params: Vendor.UpdateVendorInfo) {
      return client.put<API.Response<any>>(`${ProjectVendorsRoute}/${VendorAction}`, params);
    },
    getVendorValidations(vendorId: number) {
      const params = {vendorId};
      return client.get<API.Response<Vendor.GetVendorValidations[]>>(`${ProjectVendorsRoute}/validations`, {params});
    }
  };
};

export interface GetVendorProjectsResponse {
  classifications: IVendorListItemClassificationAssignmentEntity[];
  created: Date;
  createdBy: number | null;
  deleted: Date | null;
  deletedBy: number | null;
  id: number;
  inActivateById: number;
  inActiveDate: Date;
  inActiveMessage: string;
  isActive: boolean;
  list: IVendorListEntity;
  listId: number;
  removeRequested: boolean;
  updated: Date;
  updatedBy: number | null;
  vendor: IVendorEntity;
  vendorId: number;
  vendorName: string;
}